export const splitFullName = (fullName?: string | null): { first: string; last: string } => {
  if (!fullName?.trim()) return { first : '', last : '' };

  const parts = fullName.trim().split(/\s+/);

  return { first : parts[0], last : parts.slice(1).join(' ') };
};
